export const getDashboardPlugins = (plugins, sidebarPlugins = []) => {
	// Register the admin preview even before projects include it in their plugin
	// configuration. Analytics itself restricts its menu and route to admins.
	const allPlugins = plugins.concat(sidebarPlugins, { id: '@appmaker/firebase-analytics' });
	const seen = new Set();
	return allPlugins.filter((plugin) => {
		if (seen.has(plugin.id)) return false;
		seen.add(plugin.id);
		return true;
	});
};
